const brandedFooterClassMap = new Map<string, string>([
  ['a', 'footer-nav-item-color"'],
]);

export const brandedFooterClassBinding = Array.from(
  brandedFooterClassMap.keys(),
).map((key) => ({
  type: 'output',
  regex: new RegExp(`<${key}(.*)>`, 'g'),
  replace: `<${key} class="${brandedFooterClassMap.get(key)}" $1>`,
}));

export const removeSurroundingPElementBinding = {
  type: 'output',
  filter: function (text: string): string {
    // remove paragraphs
    text = text.replace(/<\/?p[^>]*>/g, '');
    return text;
  },
};
